/* eslint-disable react/jsx-no-bind */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { push } from 'connected-react-router';

import { setNotificationRead } from '@actions/notifications-actions';

import NotificationContents from '@components/header/notification-contents';

import ButtonBase from '@material-ui/core/ButtonBase';
import Tooltip from '@material-ui/core/Tooltip';

import { renderItemAvatar } from '@utils/logs-utils';

import './notification-item.scss';

const NotificationLinkWrap = ({ link, setRead, children }) => {
  const dispatch = useDispatch();
  if (link) {
    return (
      <ButtonBase
        onClick={() => {
          if (setRead) {
            setRead();
          }
          let linkValue = link;
          if (typeof link === 'object') {
            linkValue = link.pathname;
          }
          dispatch(push({ pathname: linkValue, state: { source: location.pathname } }));
        }}
        styleName="notification-item-container"
      >
        { children }
      </ButtonBase>
    );
  }
  return (
    <div styleName="notification-item-container">
      { children }
    </div>
  );
};

NotificationLinkWrap.propTypes = {
  children: PropTypes.node,
  link: PropTypes.object,
  setRead: PropTypes.func
};

const NotificationItem = ({ notification }) => {
  const dispatch = useDispatch();
  const agencies = useSelector(state => state.dataTypes.agency);

  const markAsRead = useCallback(notif => {
    dispatch(setNotificationRead(notif.id, !notif.read));
  }, [dispatch]);

  const { entry_object, read } = notification;
  const { attrs, entry } = entry_object;
  const { action, created } = entry;

  const setRead = useCallback(() => {
    dispatch(setNotificationRead(notification.id, true));
  }, [dispatch, notification.id]);

  // Inject the agency name into the user object:
  let { user } = entry;
  if (user && user.agency) {
    user = {
      ...user,
      agency_name: agencies[user.agency].name
    };
  }

  return (
    <NotificationLinkWrap link={attrs.link} setRead={setRead}>
      <div styleName="item-avatar">
        {renderItemAvatar(user, 'medium')}
      </div>
      <div styleName="item-content">
        <div styleName="item-main item-row">
          <div styleName="item-message">
            <NotificationContents action={action} attrs={attrs} user={user} created={created} />
          </div>
          <div styleName="item-read">
            <div
              onClick={event => {
                markAsRead(notification);
                event.stopPropagation();
              }}
              role="button"
              tabIndex="0"
              styleName="not-read-icon-wrapper"
            >
              {read && (
                <Tooltip title="mark as unread" placement="top-start">
                  <div styleName="read-icon mark-as-unread" />
                </Tooltip>
              )}
              {!read && (
                <Tooltip title="mark as read" placement="top-start">
                  <div styleName="read-icon mark-as-read" />
                </Tooltip>
              )}
            </div>
          </div>
        </div>
      </div>
    </NotificationLinkWrap>
  );
};

NotificationItem.propTypes = {
  notification: PropTypes.object
};

export default NotificationItem;
